// extracted by mini-css-extract-plugin
export var width100 = "w_s d_s";
export var design3Pos = "w_sX d_X";